let appVersion = require('../../package.json').version;

export const environment = {
  production: false,
  baseUrl : 'https://api-ssdb2.structurestudios.com/API/',
  memberUrl: 'http://localhost:4300',
  envName : 'ng',
  isDevMode : true,
  version: appVersion
};
